import React, { useState, useEffect } from "react";
import TopToolbar from "../components/TopToolbar"; // 導入 TopToolbar

function AutoSchedulingPage() {
  const getCurrentDateTime = () => {
    const now = new Date();
  
    // 手動調整到 GMT+8
    const gmt8Offset = 8 * 60 * 60 * 1000; // 8 小時的毫秒數
    const gmt8Date = new Date(now.getTime() + gmt8Offset + 120 * 1000);
  
    // 提取日期和時間部分
    const date = gmt8Date.toISOString().split("T")[0]; // 格式化為 YYYY-MM-DD
    const time = gmt8Date.toISOString().split("T")[1].slice(0, 5); // 格式化為 HH:mm
    return { date, time };
  };
  
  const { date: currentDate, time: currentTime } = getCurrentDateTime();
  const [formData, setFormData] = useState({
    device_sn: "HKAP0100000",
    customer_id: "1",
    api_send_time: currentTime, // 自動設置為當前時間
    checkin_date: currentDate, // 自動設置為當前日期
    checkout_date: new Date(Date.now() + 24 * 60 * 60 * 1000)
      .toISOString()
      .split("T")[0],
    wakeUpTime: "",
    sleepTime: "",
    morning_start_time: "06:00",
    morning_end_time: "10:00",
    morning_aroma: "Metal",
    morning_intensity_level: 60,
    afternoon_start_time: "14:00",
    afternoon_end_time: "16:00",
    afternoon_aroma: "Fire",
    afternoon_intensity_level: 30,
    evening_start_time: "18:00",
    evening_end_time: "21:00",
    evening_aroma: "Wood",
    evening_intensity_level: 70,
    late_night_start_time: "21:00",
    late_night_end_time: "22:30",
    late_night_aroma: "Earth",
    late_night_intensity_level: 50,
  });
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showModal, setShowModal] = useState(false); // 控制彈窗顯示
  const [schedules, setSchedules] = useState([]);   // 用於存儲 API 回傳的 schedules
  const [isAutoScheduling, setIsAutoScheduling] = useState(false);

  
  // 處理輸入更改
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
    setErrors((prevErrors) => ({ ...prevErrors, [name]: "" })); // 清除錯誤
  };

  // 驗證表單
  const validateForm = () => {
    const newErrors = {};
    const now = new Date();

    // 驗證 checkin_date 和 api_send_time
    const checkinDateTime = new Date(`${formData.checkin_date}T${formData.api_send_time}`);
    if (checkinDateTime < now) {
      newErrors.api_send_time = "Checkin date and time cannot be earlier than the current time.";
      newErrors.checkin_date = "Checkin date and time cannot be earlier than the current time.";
    } else if (checkinDateTime <= new Date(now.getTime() + 60 * 1000)) {
      newErrors.api_send_time = "Checkin date and time must be at least 1 minute later than the current time.";
    }

    if (!formData.device_sn) {
      newErrors.device_sn = "Device_sn is required.";
    } else if (!/^HKAP01[0-9]{8}$/.test(formData.device_sn)) {
      newErrors.device_sn =
        "Device_sn must be in the format HKAP0100000000 - HKAP0199999999.";
    }

    if (!formData.customer_id) {
      newErrors.customer_id = "Customer_id is required.";
    } else if (!/^\d+$/.test(formData.customer_id) || Number(formData.customer_id) <= 0) {
      newErrors.customer_id = "Customer_id must be a positive integer.";
    }

    if (!formData.wakeUpTime) {
      newErrors.wakeUpTime = "Wake Up Time is required.";
    }

    if (!formData.sleepTime) {
      newErrors.sleepTime = "Sleep Time is required.";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // 將 HH:mm 格式轉換為 ISO8601 格式
  const getISO8601WithTimezone = (date, time) => {
    const [hours, minutes] = time.split(":");
    const updatedDate = new Date(date);
    updatedDate.setHours(parseInt(hours, 10));
    updatedDate.setMinutes(parseInt(minutes, 10));
    updatedDate.setSeconds(0);
    return updatedDate.toISOString();
  };

  // 處理表單提交
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) {
      return;
    }

    setIsSubmitting(true);

    try {
      const requestData = {
        device_sn: formData.device_sn,
        customer_id: parseInt(formData.customer_id, 10),
        api_send_time: getISO8601WithTimezone(formData.checkin_date, formData.api_send_time),
        checkin_date: formData.checkin_date,
        checkout_date: formData.checkout_date,
        wakeup_time: formData.wakeUpTime,
        sleep_time: formData.sleepTime,
        morning_start_time: formData.morning_start_time,
        morning_end_time: formData.morning_end_time,
        morning_aroma: formData.morning_aroma,
        morning_intensity_level: formData.morning_intensity_level,
        afternoon_start_time: formData.afternoon_start_time,
        afternoon_end_time: formData.afternoon_end_time,
        afternoon_aroma: formData.afternoon_aroma,
        afternoon_intensity_level: formData.afternoon_intensity_level,
        evening_start_time: formData.evening_start_time,
        evening_end_time: formData.evening_end_time,
        evening_aroma: formData.evening_aroma,
        evening_intensity_level: formData.evening_intensity_level,
        late_night_start_time: formData.late_night_start_time,
        late_night_end_time: formData.late_night_end_time,
        late_night_aroma: formData.late_night_aroma,
        late_night_intensity_level: formData.late_night_intensity_level,
      };

      console.log("Submitting data:", requestData);

      const response = await fetch(
        "https://1700v3lt3e.execute-api.ap-east-1.amazonaws.com/kl-admin-autoscheduling",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: "kl-project-admin",
          },
          body: JSON.stringify(requestData),
        }
      );

      if (response.ok) {
        const responseData = await response.json();
        console.log("API response:", responseData);
        if (responseData.schedules && responseData.schedules.length > 0) {
          setSchedules(responseData.schedules);
          setShowModal(true);
        }
      } else {
        console.error("API request failed:", response.statusText);
        alert("API request failed: " + response.statusText);
      }
    } catch (error) {
      console.error("API request error:", error);
      alert("API request failed!");
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleAutoSchedule = async () => {
    setIsAutoScheduling(true); // 設置 Auto-Schedule 按鈕為禁用狀態

    try {
      // 確保表單中的 Device Sn (serial_number) 存在
      if (!formData.device_sn) {
        alert("Device Sn is required to auto-schedule!");
        setIsAutoScheduling(false); // 重置按鈕狀態
        return;
      }

      // 遍歷每個 schedule，逐一發送 API 請求
      for (const schedule of schedules) {
        const response = await fetch(
          "https://7dqq5knnv0.execute-api.ap-southeast-1.amazonaws.com/add-schedule",
          {
            method: "PUT",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              serial_number: formData.device_sn, // 使用表單中的 Device Sn
              timezone: "+08:00", // 假設的時區
              start_time: schedule.start_time,
              end_time: schedule.end_time,
              aroma_scent: schedule.scheduled_parameters.element,
              aroma_intensity: schedule.scheduled_parameters.intensity,
            }),
          }
        );

        if (!response.ok) {
          throw new Error(`Failed to add schedule: ${response.status}`);
        }
      }

      alert("All schedules added successfully!");
    } catch (error) {
      console.error("Error during auto-schedule:", error);
      alert("Failed to auto-schedule. Please try again.");
    } finally {
      setIsAutoScheduling(false); // 重置按鈕狀態
    }
  };

  const handleShowModal = () => {
    setShowModal(true);
    document.body.style.overflow = "hidden"; // 禁用背景滾動
  };

  const handleCloseModal = () => {
    setShowModal(false);
    document.body.style.overflow = "auto"; // 恢復背景滾動
  };

  // Inline styles for the components
  const styles = {
    container: {
      minHeight: "100vh",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      background: "linear-gradient(to bottom right, #9c27b0, #2196f3)",
      padding: "20px",
      fontFamily: "'Arial', sans-serif",
    },
    card: {
      backgroundColor: "#ffffff",
      borderRadius: "10px",
      boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)",
      padding: "20px",
      maxWidth: "500px",
      width: "100%",
    },
    heading: {
      fontSize: "24px",
      fontWeight: "bold",
      textAlign: "center",
      color: "#333",
      marginBottom: "20px",
    },
    input: {
      width: "100%",
      padding: "10px",
      margin: "10px 0",
      border: "1px solid #ccc",
      borderRadius: "5px",
      outline: "none",
      fontSize: "16px",
      boxSizing: "border-box",
    },
    inputError: {
      border: "1px solid red",
    },
    button: {
      width: "100%",
      padding: "10px",
      backgroundColor: "#2196f3",
      color: "#fff",
      border: "none",
      borderRadius: "5px",
      fontSize: "16px",
      cursor: "pointer",
      marginTop: "10px",
      transition: "background-color 0.3s",
    },
    buttonDisabled: {
      backgroundColor: "#ccc",
      cursor: "not-allowed",
    },
    label: {
      fontSize: "14px",
      color: "#555",
    },
    errorMessage: {
      fontSize: "14px",
      color: "red",
      marginTop: "5px",
    },
    modal: {
      position: "fixed",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      zIndex: 1000,
    },
    modalContent: {
      backgroundColor: "#fff",
      borderRadius: "10px",
      padding: "20px",
      width: "80%",
      maxWidth: "600px",
      textAlign: "center",
    },
    scheduleItem: {
      padding: "10px 0",
      borderBottom: "1px solid #ccc",
    },
    closeButton: {
      marginTop: "10px",
      padding: "10px 20px",
      backgroundColor: "#2196f3",
      color: "#fff",
      border: "none",
      borderRadius: "5px",
      cursor: "pointer",
    },
    autoScheduleButton: {
      marginRight: "10px",
      padding: "10px 20px",
      backgroundColor: "#4caf50", // 綠色
      color: "#fff",
      border: "none",
      borderRadius: "5px",
      cursor: "pointer",
      fontSize: "16px",
      transition: "background-color 0.3s",
    },  
    autoScheduleButtonDisabled: {
      backgroundColor: "#ccc", // 灰色
      cursor: "not-allowed",
      color: "#666", // 確保文字顏色在禁用時可讀
    },
    scheduleList: { // 在這裡加入
      maxHeight: "300px",
      overflowY: "auto",
      width: "100%",
      margin: "10px 0",
    },
  };

  // 當 showModal 改變時執行副作用
  useEffect(() => {
    if (showModal) {
      document.body.style.overflow = "hidden"; // 禁用背景滾動
    } else {
      document.body.style.overflow = "auto"; // 恢復背景滾動
    }

    // 清理函數，確保在組件卸載時恢復背景滾動
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [showModal]);

  return (
    <div style={styles.container}>
      
        <form onSubmit={handleSubmit} style={styles.card}>

        <TopToolbar /> {/* 使用 TopToolbar */}
          <h1 style={styles.heading}>Schedule Transaction API</h1>
          {Object.keys(formData).map((key) => (
            <div key={key}>
              <label style={styles.label}>
                {key.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase())}
                {["device_sn", "customer_id", "wakeUpTime", "sleepTime"].includes(
                  key
                ) && "*"}
              </label>
              <input
                type={
                  key.includes("time") && key !== "api_send_time"
                    ? "time"
                    : key.includes("date")
                      ? "date"
                      : key === "api_send_time"
                        ? "time"
                        : "text"
                }
                name={key}
                value={formData[key]}
                onChange={handleInputChange}
                style={{
                  ...styles.input,
                  ...(errors[key] ? styles.inputError : {}),
                }}
              />
              {errors[key] && <p style={{ color: "red" }}>{errors[key]}</p>}
            </div>
          ))}
          <button
            type="submit"
            disabled={isSubmitting}
            style={{
              ...styles.button,
              ...(isSubmitting ? styles.buttonDisabled : {}),
            }}
          >
            {isSubmitting ? "Submitting..." : "Submit"}
          </button>
        </form>
      

      {showModal && (
        <div style={styles.modal}>
          <div style={styles.modalContent}>
            <h2>Schedules</h2>
            <div style={styles.scheduleList}> {/* 新增滾動容器 */}
              {schedules.map((schedule, index) => (
                <div key={index} style={styles.scheduleItem}>
                  <p>
                    <strong>Start Time:</strong> {schedule.start_time}
                  </p>
                  <p>
                    <strong>End Time:</strong> {schedule.end_time}
                  </p>
                  <p>
                    <strong>Aroma:</strong> {schedule.scheduled_parameters.element}
                  </p>
                  <p>
                    <strong>Intensity:</strong> {schedule.scheduled_parameters.intensity}
                  </p>
                </div>
              ))}
            </div>
            <button
              onClick={handleAutoSchedule}
              disabled={isAutoScheduling} // 根據 isAutoScheduling 狀態禁用按鈕
              style={{
                ...styles.autoScheduleButton,
                ...(isAutoScheduling ? styles.autoScheduleButtonDisabled : {}),
              }}
            >
              {isAutoScheduling ? "Scheduling..." : "Auto-Schedule"}
            </button>
            <button onClick={handleCloseModal} style={styles.closeButton}>
              Close
            </button>
          </div>
        </div>
      )}

    </div>
  );
}

export default AutoSchedulingPage;